$(document).ready(function () {
  if ($(window).width() > 1024) {
    $('.product-card__card').on('mousemove', function (e) {
      const $card = $(this)
      const offset = $card.offset()
      const width = $card.outerWidth()
      const x = e.pageX - offset.left

      const partWidth = width / 4
      const index = Math.floor(x / partWidth) // 0, 1, 2, 3

      $card
        .find('.product-card__photo')
        .removeClass('is-active')
        .eq(index)
        .addClass('is-active')

      // Оновлюємо позицію .product-card-progress__bar
      const leftPercent = index * 25
      $card.find('.product-card-progress__bar').css('left', `${leftPercent}%`)
    })

    $('.product-card__card').on('mouseleave', function () {
      const $card = $(this)
      $card
        .find('.product-card__photo')
        .removeClass('is-active')
        .eq(0)
        .addClass('is-active')

      // Повертаємо прогрес бар у початкову позицію
      $card.find('.product-card-progress__bar').css('left', '0%')
    })
  }

  // Product card color
  $('.product-card__color').on('click', function () {
    $(this).addClass('is-active').siblings().removeClass('is-active')
  })

  // Product card slider
  $('.product-slider--variable-width .product-slider__items').slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
  })

  $('.product-slider--4 .product-slider__items').slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          variableWidth: true,
        },
      }
    ],
  })

  // Product card slider
  $('.intro__items').slick({
    dots: false,
    arrows: false,
    infinite: true,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
  })

  setTimeout(function () {
    $('#bestsellers').addClass('in active')
  }, 200)
})
